import { ContentBox } from "@arelia-components/ui-atoms/ContentBox";
import Header from "@arelia-components/layout/Header";
import RoyaltiesDetailsTableContainer from "./RoyaltiesDetailsTableContainer";

export default function PublishingRoyaltiesBreakdown() {
  return (
    <ContentBox>
      <Header
        title="Publishing Royalties Details"
        backTo={{
          label: "back to royalties",
          path: "/earnings/publishing-royalties"
        }}
      />
      <RoyaltiesDetailsTableContainer />
    </ContentBox>
  );
}
